import { NotificationService } from 'src/app/shared/services/notification.service';
import { inject, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BaseServices } from 'src/app/kuba/kuba.services';

import { Rights } from 'src/app/_models';
import { ConfirmationService } from 'primeng/api';
import { OtherSystem, OtherSystemUser } from '../models/other-system';
import { OtherSystemService } from '../services/other-system.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-other-system-list',
  templateUrl: './other-system-list.component.html',
  standalone: false
})
export class OtherSystemListComponent implements OnInit {
  private readonly notifications = inject(NotificationService);
  otherSystemList: OtherSystem[];
  isAdministrateOs = true;
  isHideDeleteIcon = true;
  additionalData: any;
  isDisabled: boolean;

  assignedUsers: OtherSystemUser[] = [];
  showDialog = false;
  private subscriptions: Subscription[] = [];

  /**
   *
   * @param otherSystemService {{otherSystemServices}}
   * @param confirmationService {{ConfirmationService}}
   * @param route {{ActivatedRoute}}
   * @param intrnlcntrlsrvc {{InternalControlServices}}
   */
  constructor(
    private otherSystemService: OtherSystemService,
    private confirmationService: ConfirmationService,
    private route: ActivatedRoute,
    private translate: TranslateService,
    private router: Router
  ) {
    this.subscriptions.push(
      this.translate.stream('FILENAME').subscribe(val => {
        this.additionalData = {
          fileName: val.OTHER_SYSTEMS_LIST,
          header: 'Other System List',
          businessId: BaseServices.BusinessId,
          cultureInfo: BaseServices.userCultureInfo(),
          columnNames: [
            { title: 'Name of the task', dataKey: 'Title' },
            { title: 'Description', dataKey: 'Description' },
            { title: 'Assigned Access', dataKey: 'UserCount' },
            { title: 'Deviations In Followup', dataKey: 'ShowDeviationreport' }
          ]
        };
      })
    );
  }

  /**
   * Initializes the page and handles auto redirect routing
   */
  ngOnInit() {
    document.querySelector('body').classList.remove('opened');
    this.isDisabled = true;
    let otherSystems = this.route.snapshot.data['list'];
    if (otherSystems != null) {
      this.otherSystemList = otherSystems;
    }
    this.onAdministrateOtherSystem();

    let os = sessionStorage.getItem('checkParent');

    if (otherSystems.length === 1) {
      if (os === 'OS') {
        this.router.navigate(['./../../list'], { relativeTo: this.route });
      } else {
        const otherSystem: OtherSystem = otherSystems[0];
        this.autoRedirectToOs(otherSystem);
      }
    }
    sessionStorage.setItem('checkParent', null);
  }

  /**
   * Navigates the user to the Other System if they have access to it.
   * If not, they will likely just see an empty list.
   * @param otherSystem OS to navigate to
   */
  autoRedirectToOs(otherSystem: OtherSystem) {
    if (this.isAdministrateOs) {
      this.router.navigate(['./../../details/' + otherSystem.Id], {
        relativeTo: this.route
      });
    } else {
      const userId = BaseServices.UserId;
      if (otherSystem.OSUserDto.find(osu => osu.UserId === userId)) {
        this.router.navigate(['./../../details/' + otherSystem.Id], {
          relativeTo: this.route
        });
      }
    }
  }

  onHide() {
    this.showDialog = false;
  }

  /**
   * Opens a popup showing the assigned users in an Other System
   * @param assignedUsers Assigned users in an OS
   */
  showAssignedUsers(assignedUsers: OtherSystemUser[]) {
    this.showDialog = true;
    this.assignedUsers = [];
    this.assignedUsers = assignedUsers;
  }

  /**
   * get list of all Other Systems
   */
  getAllOtherSystems() {
    this.subscriptions.push(
      this.otherSystemService
        .getAll(BaseServices.BusinessId)
        .subscribe(result => (this.otherSystemList = result))
    );
  }

  /**
   * delete internal control
   * @param control {{any}}
   */
  confirm(control) {
    this.confirmationService.confirm({
      message: this.translate.instant('DELETE_THIS_RECORD'),
      accept: () => {
        this.otherSystemService.deleteControl(control).then(result => {
          if (result) {
            this.notifications.success('UI_NOTIFICATIONS.DELETED');
            this.getAllOtherSystems();
          }
        });
      }
    });
  }

  /**
   * Edit & update OS based on administrate OS rights
   */
  onAdministrateOtherSystem() {
    let userRightsId = Rights.ADMINISTRATE_OTHER_SYSTEMS;
    let role = BaseServices.UserRole;
    if (role === 'User') {
      this.isHideDeleteIcon = false;
      this.isAdministrateOs = BaseServices.checkUserRights(userRightsId, role);
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub, i) => {
      sub.unsubscribe();
    });
  }
}
